var enLang = {
	"Dữ liệu không hợp lệ": "Invalid data",
	"Dữ liệu loyalty không hợp lệ": "Invalid loyalty data",
	"Dữ liệu Takashimaya không hợp lệ": "Invalid Takashimaya data",
	"Dữ liệu loyalty ngoài giá trị cho phép": "Loyalty data is out of range",
	"Dữ liệu Takashimaya ngoài giá trị cho phép": "Takashimaya data is out of range",
	"Thành viên đã tồn tại": "Member existed already",
	"Nhập thiếu giá trị bắt buộc": "Missing required fields",
	"Giá trị không nằm trong tập cho phép": "Inputted value is out of range",
	"Không có quyền truy cập Loyalty": "No permission to access loyalty",
	"Không có quyền truy cập Takashimaya": "No permission to access Takashimaya",
	"Không có quyền truy cập": "No access permission",
	"Không tìm thấy cấu hình loyalty network": "Loyalty network configuration not found",
	"Không tìm thấy chứng chỉ xác thực loyalty": "Loyalty authentication cert not found",
	"Không tìm thấy loyalty tier": "Loyalty tier not found",
	"Số điện thoại đã được sử dụng": "Phone number existed already",
	"Chứng chỉloyalty đã được sử dụng": "Loyatly cert has been used already",
	"Số điện thoại cho Takashimaya đã được sử dụng": "Phone number has been used for Takashimaya",
	"Loyalty network không hoạt động": "Loyalty network not working",
	"Loyalty merchant không hoạt động": "Loyalty merchant not working",
	"Takashimaya network không hoạt động": "Takashimaya network not working",
	"Trả góp chỉ áp dụng cho đơn hàng có giá trị từ 3 triệu đồng trở lên": "Installment only applies to orders with a value of 3 million VND or more"
};

export { enLang as default };
